export const isBase64 = (str: string) => str?.includes('base64');
